export default __webpack_public_path__ + "static/media/032-gorilla.e2358f99.svg";